const findColorShadeInPalette = (targetColor, palette, checkAlpha) => {
  const paletteKeys = Object.keys(palette);
  const colorKey = paletteKeys.find((key) => {
    const paletteColor = palette[key];
    return paletteColor.equals(targetColor, checkAlpha);
  });

  return colorKey || null;
};

export default findColorShadeInPalette;
